import React, { useState, useEffect } from "react";
import {
  FaFolder,
  FaFolderOpen,
  FaFile,
  FaTrashAlt,
  FaDownload,
} from "react-icons/fa";
// CAMBIO 1: Importar del nuevo servicio
import {
  listFoldersInBucket,
  listFiles,
  downloadFile,
  deleteFile,
} from "../services/files";
import { useAuth } from "react-oidc-context";
import { buildFileTree } from "../utils/buildFileTree"; // Asumo que este util sigue existiendo
import "../styles/FileExplorer.css";

// Filtra recursivamente (Misma lógica que tenías)
function filterTree(node, term) {
  const nameMatches = node.name.toLowerCase().includes(term);
  const children = Object.entries(node.children)
    .map(([key, child]) => filterTree(child, term))
    .filter(Boolean)
    .reduce((acc, child) => {
      acc[child.name] = child;
      return acc;
    }, {});
  const files = node.files.filter(file =>
    file.name.toLowerCase().includes(term)
  );
  if (nameMatches || files.length > 0 || Object.keys(children).length > 0) {
    return { ...node, children, files };
  }
  return null;
}

const TreeNode = ({ node, onRefresh }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="tree-node">
      <div className="node-label" onClick={() => setOpen(!open)}>
        {open ? <FaFolderOpen /> : <FaFolder />} <span>{node.name}</span>
      </div>

      {open && (
        <div className="node-children">
          {Object.values(node.children).map((child, i) => (
            <TreeNode
              key={i}
              node={child}
              onRefresh={onRefresh}
            />
          ))}

          {node.files.map((file, i) => (
            <div key={i} className="tree-file">
              <FaFile /> {file.name}
              <button
                onClick={() => downloadFile(file)}
                title="Descargar"
              >
                <FaDownload />
              </button>
              <button
                onClick={() => deleteFile(file, onRefresh)}
                title="Eliminar"
              >
                <FaTrashAlt />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const FileExplorer = () => {
  const auth = useAuth();

  const [searchTerm, setSearchTerm] = useState("");
  const [folders, setFolders] = useState([]);
  const [loadingFolders, setLoadingFolders] = useState(true);
  const [, setFoldersError] = useState(null);

  const [files, setFiles] = useState([]);
  const [, setLoadingFiles] = useState(false);
  const [, setFilesError] = useState(null);

  // 1. Listar carpetas
  useEffect(() => {
    if (auth.isLoading) return;
    if (!auth.isAuthenticated) {
        setLoadingFolders(false);
        return;
    }

    setLoadingFolders(true);
    // CAMBIO 2: No pasamos idToken manual
    listFoldersInBucket()
      .then(list => setFolders(list))
      .catch(err => {
        console.error("Error obteniendo carpetas:", err);
        // Fallback visual si el endpoint no existe aún
        setFoldersError(null);
      })
      .finally(() => setLoadingFolders(false));
  }, [auth.isLoading, auth.isAuthenticated]);

  // 2. Listar archivos
  useEffect(() => {
    if (loadingFolders) return;
    // Si no hay carpetas, intentamos cargar archivos generales
    const foldersToSearch = folders.length > 0 ? folders : ["root"];

    setLoadingFiles(true);

    // Aquí podrías ajustar la lógica si tu API permite listar todo de una vez
    listFiles(foldersToSearch)
      .then(result => {
         // Ajuste por si el resultado no es un array plano
         const fileList = Array.isArray(result) ? result : [];
         setFiles(fileList);
      })
      .catch(err => {
        console.error("Error listando archivos:", err);
        setFilesError("No se pudieron cargar los archivos.");
      })
      .finally(() => setLoadingFiles(false));
  }, [loadingFolders, folders]);

  // ... (Bloques de IF de carga iguales que antes) ...
  if (auth.isLoading || loadingFolders) return <div>Obteniendo carpetas…</div>;
  if (!auth.isAuthenticated) return <div>No estás autenticado.</div>;

  // 4. Construir árbol
  const fullTree = buildFileTree(files);
  const term = searchTerm.trim().toLowerCase();
  const rootNodes = Object.values(fullTree.children);
  const displayedNodes = term
    ? rootNodes.map(node => filterTree(node, term)).filter(Boolean)
    : rootNodes;

  return (
    <div className="file-explorer">
      <div className="search-container">
        <input
          type="text"
          className="search-input"
          placeholder="Buscar carpetas o archivos..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
      </div>

      {displayedNodes.map((node, i) => (
        <TreeNode
          key={i}
          node={node}
          onRefresh={() => {
             // Lógica simple de refresco
             setLoadingFiles(true);
             listFiles(folders).then(setFiles).finally(() => setLoadingFiles(false));
          }}
        />
      ))}
    </div>
  );
};

export default FileExplorer;
